// extracted by mini-css-extract-plugin
export default {"CourseHolder":"UserPanelAllCourses_CourseHolder__Fyksa"};